import React from 'react'
import TourTile from '../TourTiles/TourTile'
import TourTileSkeletonLoader from '../TourTiles/TourTileSkeletonLoader'
import { VIRGIN_VELOCITY_PARTNERSHIP_CODE } from 'constants/partnerships'
import { connect } from 'react-redux'
import { useInView } from 'react-intersection-observer'
import useOffer from 'hooks/Offers/useOffer'
import offerPageURL from 'lib/offer/offerPageURL'

interface MappedProps {
  isVelocityEnabled: boolean;
}

interface Props {
  id: string;
  index: number;
  lazyLoad?: boolean;
  category?: string;
}

function TourOfferLoadTile(props: Props & MappedProps) {
  const { isVelocityEnabled, category, id, lazyLoad, index } = props
  const [inViewRef, inView] = useInView({ triggerOnce: true, initialInView: false, threshold: 0, rootMargin: '500px' })
  const [tour, isOfferFetching, offerError] = useOffer<Tours.V2Offer>(id, { disabled: lazyLoad && !inView })

  if (offerError) {
    return null
  }

  return (
    <div ref={inViewRef}>
      {isOfferFetching && <TourTileSkeletonLoader key={index} />}
      {tour && tour.purchasableOptions.length > 0 && (
        <TourTile isVelocityEnabled={isVelocityEnabled} key={tour.id} to={offerPageURL(tour)} tour={tour} index={index} category={category}/>
      )}
    </div>
  )
}

const mapStateToProps = (state: App.State): MappedProps => ({
  isVelocityEnabled: state.geo.partnership?.code === VIRGIN_VELOCITY_PARTNERSHIP_CODE,
})

export default connect(mapStateToProps)(TourOfferLoadTile)
